import template from 'product-meta/price.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

import { pushModalTransition } from '../../../core/js/actions/modalActions';
import { init as afterpayInfoModalInit } from '../../../core/js/components/afterpayInfoModalComponent';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-product-meta-price',
        watch: 'product.productMeta',
        template: template,
        name: 'productMetaPriceComponent',
        forFamilyProduct: false,
        onStateChange: onStateChange,
        attachEvents: attachEvents
    };

    return generate(config, store, overrides);
}

function attachEvents() {
    $(document).on(
        this.scopedEvent('click'),
        this.scopedSelector('.js-afterpay-info'),
        (e) => {
            e.preventDefault();
            const payload = pushModalTransition(afterpayInfoModalInit, this.getInheritedOverrides(), e, this.name);

            $.event.trigger({
                type: payload.type,
                payload: payload
            });
        }
    );
}
